<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-overlay :show="searchIsRunning" rounded>
          <b-card>
            <SearchForm @search="$event => onSearch($event)"/>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <template v-for="(result, resultIndex) in results">
      <Result :key="'result' + resultIndex" :result="result" :selected="isSelected(result)" :params="params"
        @toggle="onToggle(result)" @info="onInfo([result])"/>
    </template>
    <NoResultsWarning v-if="searchIsDone && results.length === 0"/>
    <SelectedResults :results="selectedResults" v-show="selectedResults.length" @hide="onHideSelected()"
      @info="onInfoSelected()" />
    <!--info modal-->
    <b-modal v-model="modal" title="Info Modal" size="xl" hide-header hide-footer>
      <div id="printArea">
        <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="onModalClose" />
        <!-- <b-card class="bg-light" no-body>
          <SearchParamsSummary :params="model.params"/>
        </b-card> -->
        <b-row v-for="result in infoResults" :key="'detailedInfo' + result.id">
          <DetailedResult :result="result"></DetailedResult>
        </b-row>
      </div>
      <ModalFooter @closeModal="onModalClose" />
    </b-modal>

  </div>
</template>

<script>
import viewMixin from '../shared/mixins/search_views'
import { search, getSearchResults } from 'b2b-common/services/api/tour'
import SearchForm from './components/search_form'
import Result from './components/result.vue'
import DetailedResult from './components/detailed_result.vue'
import SelectedResults from '@/app/private/shared/components/selected_results'
import ModalHeader from '@/app/private/shared/components/modal_header'
import ModalFooter from '@/app/private/shared/components/modal_footer'
import NoResultsWarning from './components/no_results_warning.vue'

export default {
  components: {
    SearchForm,
    Result,
    SelectedResults,
    DetailedResult,
    ModalHeader,
    ModalFooter,
    NoResultsWarning
  },
  mixins: [viewMixin],
  data () {
    return {
      results: [],
      searchIsDone: false,
      hasTransport: false,
      searchIsRunning: false,
      selectedResultIndex: null,
      selectedDate: null,
      params: {}
    }
  },
  methods: {
    async onSearch (params) {
      this.searchIsRunning = true
      this.searchIsDone = false
      this.selectedDate = null
      this.results = []
      try {
        this.params = { ...params }
        this.results = await search(params)
        this.searchIsDone = true
      } catch (e) {
      } finally { this.searchIsRunning = false }
    },
    selectResult (index, date) {
      this.selectedResultIndex = index
      this.selectedDate = date
    }
  },
  async mounted () {
    this.results = await getSearchResults()
  }
}
</script>
